/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as TYPES from './group-action-types';

import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  getAllContactType,
  getExistingContactDetails,
} from '../../Plan/store/actions';

export const setSelectedClientAction = (payload) => {
  return {
    type: TYPES.SELECTED_CLIENT_ACTION_TYPES,
    payload,
  };
};

export const setMainGroupDetailsAction = (payload) => {
  return {
    type: TYPES.MAINTIN_GROUP_DETAILS_ACTION_TYPES,
    payload,
  };
};
export const setCompareData = (payload) => {
  return {
    type: TYPES.MAINTAIN_GROUP_COMPARE_DATA,
    payload,
  };
};

export const setClientIdDropdownAction = (payload) => {
  return {
    type: TYPES.CLIENT_ID_DROPDOWN_ACTION_TYPES,
    payload,
  };
};

export const setGroupDataChangeTried = (payload) => {
  return {
    type: TYPES.GROUP_DATA_CHANGE_TRIED,
    payload,
  };
};

export const getAllClientsDropDown = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CLIENTS_FOR_PLAN)
    .then((response) => {
      return dispatch(setClientIdDropdownAction(response.data.data));
    })
    .catch(() => {
      dispatch(setClientIdDropdownAction([]));
    });
};

export const setAddGroup = (payload) => {
  return {
    type: TYPES.GROUP_ADD_ACTION_TYPES,
    payload,
  };
};

export const setClientDataAction = (payload) => {
  return {
    type: TYPES.CLIENT_DATA_ACTION_TYPES,
    payload,
  };
};

export const setMaintainGroupParticipationDatesAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_GROUP_PARTICIPATION_DATES_ACTION_TYPES,
    payload,
  };
};
export const setCreateGrpOpt = (payload) => ({
  type: TYPES.CREATE_NEW_GRP_OPT,
  payload,
});

export const setMaintainGroupPlansAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_GROUP_PLANS_ACTION_TYPES,
    payload,
  };
};
export const saveOrFailRes = (payload) => {
  return {
    type: TYPES.SAVE_OR_FAIL_RES,
    payload,
  };
};

export const setMaintainGroupContactAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_GROUP_CONTACT_ACTION_TYPES,
    payload,
  };
};
export const getAllContactTypeProvider = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DESCRIPTION_DETAILS, value)
    .then((response) => {
      return dispatch(dispatchContactType(response.data));
    })
    .catch(() => {
      dispatch(dispatchContactType([]));
    });
};
export const setGroupTabDataAction = (payload) => {
  return {
    type: TYPES.GROUP_TAB_DATA,
    payload,
  };
};

export const addParticipationDate = (payload) => {
  return (dispatch, getState) => {
    const currentParticpationDates = [
      ...getState().sharedState.GroupReducer.particpationDates,
    ];

    currentParticpationDates.push(payload);

    dispatch(
      setMaintainGroupParticipationDatesAction(currentParticpationDates)
    );
  };
};

export const updateParticipationDate = (index, isExistingComment) => {
  return (dispatch, getState) => {
    let currentParticpationDates = [
      ...getState().sharedState.GroupReducer.particpationDates,
    ];

    currentParticpationDates[index] = {
      ...currentParticpationDates[index],
      isExistingComment,
    };

    dispatch(
      setMaintainGroupParticipationDatesAction([...currentParticpationDates])
    );
  };
};

export const getGroupDetailsAPI = async (groupId, clientId) => {
  try {
    const response = await axios.post(serviceEndPoint.GET_GROUP_DETAILS, {
      groupId,
      clientId,
    });

    return response.data.data;
  } catch (e) {
    return [];
  }
};

export const getExistingCommentLinkIds = async (idList) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
      {
        corrLinkId: idList,
      }
    );
    return response.data?.data ?? [];
  } catch (e) {
    return [];
  }
};

export const updateParticipationUserId = (index, userId, date) => {
  return (dispatch, getState) => {
    const currentParticpationDates = [
      ...getState().sharedState.GroupReducer.particpationDates,
    ];

    currentParticpationDates[index] = {
      ...currentParticpationDates[index],
      lastUpdateDt: date,
      lastUpdateUserId: userId,
    };

    dispatch(
      setMaintainGroupParticipationDatesAction(currentParticpationDates)
    );
  };
};

export const setGroupDetailsAndParticptionDates = (
  groupId,
  clientId,
  isNew = false
) => {
  return async (dispatch) => {
    const response = await getGroupDetailsAPI(groupId, clientId);
    if (response.length > 0) {
      let updatedData = response.map((item, index) => {
        return {
          ...item,
          index,
        };
      });
      const obj = {
        clientName: updatedData[0].clientName,
        groupName: updatedData[0].groupName,
        clientId: updatedData[0].clientGroupId.clientId,
        groupId: updatedData[0].clientGroupId.groupId,
      };
      dispatch(setMainGroupDetailsAction({ ...obj }));
      const existingCommentIdList = await getExistingCommentLinkIds(
        updatedData.map((item) => item.corrLinkId)
      );
      updatedData = updatedData?.map((item) => ({
        ...item,
        isExistingComment: existingCommentIdList.includes(item.corrLinkId)
          ? 1
          : 0,
      }));
      dispatch(setMaintainGroupParticipationDatesAction([...updatedData]));
      dispatch(
        setCompareData({
          details: _.cloneDeep(obj),
          data: _.cloneDeep(updatedData),
        })
      );
      dispatch(setGroupDataChangeTried(Math.random()));
      dispatch(getAllContactType({ keyTypeCd: 'CG' }, 'group'));
      dispatch(
        getExistingContactDetails(
          {
            key: [`${obj?.clientId?.trim()}${obj?.groupId?.trim()}`],
            keyTypeCd: 'CG',
          },
          'group'
        )
      );
    } else {
      dispatch(setMainGroupDetailsAction(null));
      dispatch(setMaintainGroupParticipationDatesAction([]));
      dispatch(setCompareData({ details: null, data: [] }));
      dispatch(setGroupDataChangeTried(Math.random()));
    }

    if (isNew) {
      dispatch(setIntialContactDetails({}));
    }
  };
};

export const setErrorPopup = (payload) => {
  return {
    type: TYPES.ERROR_POPUP_ACTION_TYPES,
    payload,
  };
};

export const deleteGroup = (deleteArray) => {
  return async (dispatch, getState) => {
    const groupDetails = getState().sharedState.GroupReducer.mainGroupDetails;
    if (!groupDetails || !groupDetails.clientId || !groupDetails.groupId) {
      dispatch(setErrorPopup('Something went wrong'));
    } else {
      const response = await getAllPlanAPI({
        groupId: groupDetails.groupId,
        clientId: groupDetails.clientId,
      });

      if (response && response.length > 0) {
        dispatch(
          setErrorPopup(
            'To delete a group there cannot be any corresponding plans'
          )
        );
      } else {
        const filterDeleteArray = deleteArray.filter((item) => !item.newRecord);
        const deleteGroupRes = await deleteGroupDetils(filterDeleteArray);
        if (deleteGroupRes) {
          dispatch(setNaviagtionListner('group'));
        } else {
          dispatch(setErrorPopup('Something went wrong'));
        }
      }
    }
  };
};

export const setNaviagtionListner = (payload) => {
  return {
    type: TYPES.NAVIGATION_LISTENER_ACTION_TYPES,
    payload,
  };
};

export const deleteParticipationDate = (index, rowData) => {
  return async (dispatch, getState) => {
    let currentParticpationDates = [
      ...getState().sharedState.GroupReducer.particpationDates,
    ];

    if (rowData && !rowData.newRecord) {
      if (currentParticpationDates.length > 1) {
        // await deleteGroupDetils([rowData]);
        // currentParticpationDates = currentParticpationDates.filter(
        //   (item) => item.index !== index
        // );
        currentParticpationDates = currentParticpationDates.map((item) =>
          item.index === index ? { ...item, deleted: true } : item
        );

        dispatch(
          setMaintainGroupParticipationDatesAction(currentParticpationDates)
        );
        dispatch(setGroupDataChangeTried(Math.random()));
      } else {
        dispatch(deleteGroup(currentParticpationDates));
      }
    } else if (currentParticpationDates.length === 1) {
      dispatch(deleteGroup(currentParticpationDates));
    } else {
      currentParticpationDates = currentParticpationDates.filter(
        (item) => item.index !== index
      );

      dispatch(
        setMaintainGroupParticipationDatesAction(currentParticpationDates)
      );
      dispatch(setGroupDataChangeTried(Math.random()));
    }
  };
};

export const updateContactDetails = async (values) => {
  try {
    await axios.post(serviceEndPoint.UPDATE_CONTACT_DETAILS, values);
    return 'Success';
  } catch (e) {
    return null;
  }
};
export const getContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DETAILS, values)
    .then((response) => {
      if (response.data && response.data[0]) {
        dispatch(setIntialContactDetails(response.data[0]));
      } else {
        dispatch(setIntialContactDetails({ ...values }));
      }
    })
    .catch(() => {
      dispatch(setIntialContactDetails({ ...values }));
    });
};

export const dispatchUpdateContactDetail = (message) => {
  return {
    type: TYPES.UPDATE_CONTACT_DETAILS,
    updateOrSaveContactDetailsMessage: message,
  };
};

export const dispatchContactType = (values) => {
  return {
    allContactTypeDropDown: values,
    type: TYPES.GET_CONTACT_TYPE,
  };
};

export const dispatchSelectedGroup = (values) => {
  return {
    type: TYPES.SET_SELECTED_GROUP,
    payload: values,
  };
};

export const dispatchClearsuccessFail = () => {
  return {
    type: TYPES.CLEAR_SAVE_OR_FAIL_RES
  };
};

export const dispatchExistingContactDetails = (data) => ({
  type: TYPES.GET_EXISTING_CONTACT_DETAILS,
  existingContactDetails: data,
});
export const dispatchContactDetails = (data) => ({
  type: TYPES.GET_CONTACT_DETAILS,
  contactDetails: data,
});

export const dispatchCompareContactDetails = (payload) => ({
  type: TYPES.COMPARE_GROUP_CONTACT_INFO,
  payload,
});

export const updateContactDetailsInRedux = (
  key,
  value,
  objectValue,
  isObj = false
) => {
  return (dispatch, getState) => {
    if (isObj) {
      dispatch(dispatchContactDetails(objectValue));
    } else {
      const currentData = {
        ...(getState().sharedState.GroupReducer.contactDetails || {}),
      };

      const currentCompareData = {
        ...(getState().sharedState.GroupReducer.compareContactDetails || {}),
      };

      if (!value && Object.keys(currentCompareData).length < 5) {
        delete currentData[key];
      } else {
        currentData[key] = value;
      }
      dispatch(dispatchContactDetails(currentData));
    }
  };
};

export const setIntialContactDetails = (payload) => {
  return (dispatch) => {
    dispatch(dispatchContactDetails(payload));
    dispatch(dispatchCompareContactDetails(_.cloneDeep(payload)));
  };
};

export const getAllPlanAPI = async (values) => {
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_PLAN}`,
      values
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getAllPlans = (values) => {
  return async (dispatch) => {
    const response = await getAllPlanAPI(values);
    if (response) {
      dispatch(setMaintainGroupPlansAction(response));
    } else {
      dispatch(setMaintainGroupPlansAction([]));
    }
  };
};

export const saveOrUpdateGroup = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_OR_UPDATE_GROUP, values)
    .then((response) => {
      dispatch(saveOrFailRes(response));
    })
    .catch((error) => {
      dispatch(saveOrFailRes(error));
    });
};

export const deleteGroupDetils = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.DELETE_GROUP_DETAILS,
      values
    );

    return response;
  } catch (e) {
    return null;
  }
};
export const clearReduxForMaintainGroupScreen = (payload) => {
  // const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  // if (
  //   (payload === '/group' &&
  //     !updateTabs.filter((x) => {
  //       return x.navTo === '/group-maintain';
  //     }).length > 0) ||
  //   (payload === '/group-maintain' &&
  //     !updateTabs.filter((x) => {
  //       return x.navTo === '/group';
  //     }).length > 0)
  // ) {
  //   return {
  //     type: TYPES.SET_CLEAR_REDUX_DATA,
  //     payload,
  //   };
  // }
  // return null;
};
